import http from "./http.js";
import useVatTypes from "../helpers/useVatTypes.js";

async function getPackage(id) {
  try {
    const response = await http.get(`payment-packages/${id}`);

    let useVAT = "";
    for (const useVatType in useVatTypes) {
      if (useVatTypes[useVatType].value === response.data.useVAT) {
        useVAT = useVatType;
      }
    }

    return {
      title: response.data.title,
      article: response.data.article,
      useVAT,
      paymentPackageType: response.data.paymentPackageType.id,
      amount: response.data.amount,
      amountWithVAT: response.data.amountWithVAT,
      comments: response.data.comments,
      baseRateHours: response.data.baseRateHours,
    };
  } catch (err) {
    throw err;
  }
}

async function updatePackage(id, pack) {
  try {
    const response = await http.put(`payment-packages/${id}`, pack);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createPackage(pack) {
  try {
    const response = await http.post("payment-packages", pack);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getPackages(page = 1, rowsPerPage = 9, search = "", filter = "") {
  try {
    const response = await http.get("payment-packages", {
      params: {
        page,
        pageSize: rowsPerPage,
        searchTerm: search,
        saleOption: filter?.saleOption.toString() || "",
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function selectPackage(page = 1, rowsPerPage = 9, search = "") {
  try {
    const response = await http.get(
      "payment-packages/references", {
        params: {
          page,
          pageSize: rowsPerPage,
          searchTerm: search,
        },
      });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { selectPackage, getPackage, updatePackage, createPackage, getPackages };
